import React, { useEffect } from "react";

/**
 * Calls a callback when the the event fires
 * @param {HTMLElement | Window} ref
 * @param {string} event
 * @param {() => void} callback 
 */
const useEventEffect = (ref, event, callback, enabled = true) => {
  useEffect(() => {
    if(callback && ref && enabled) {
      ref && ref.addEventListener(event, callback);
      return () => ref && ref.removeEventListener(event, callback);
    }
  }, [callback, ref, enabled]);
};
  
export default useEventEffect